import {isPickPack} from "@Common/logic/item/is-pick-pack";
import {isNotEmpty} from "@Common/utils/objects";

import {CustomizeLayout} from "../../common/customize-layout/customize-layout";

export const LoadLayout = ({item, company, next}) => CustomizeLayout({
    back: {
        link: item.source === 'OIA' || isPickPack(item) || item.uyoMPB ? (
            `/product-options/order/${item?.itemId}`
        ) : item?.metaData?.ccReferenceURLs || company?.prefs?.allowBuild3 ? (
            `/customize/order/${item?.itemId}`
        ) : (
            `/next/start.php?action=edit&id_order=${item?.itemId}&order_exists=exists&procform=1&redirect=customize`
        ),
        label: item.source === 'OIA' || isPickPack(item) || item.uyoMPB ? (
            "Back to Product Options"
        ) : (
            "Back to Customize"
        ),
    },
    addressable: item.addressable,
    customizable: item.source !== 'OIA' && !isPickPack(item) && !item.uyoMPB,
    isKit: isNotEmpty(item?.components),
    active: "distribution-options",
    disabled: ["checkout"],
    item,
    next,
});
